<script>
  import {onMount, createEventDispatcher} from 'svelte';
  import {activationStatus$} from '@/streams/auth';
  import Button from '@/widgets/Button.svelte';
  import Modal from '@/widgets/Modal.svelte';
  import lang from './WelcomeBackDialog.lang';

  export let LG;

  const dispatch = createEventDispatcher();

  onMount(() => {
    setTimeout(() => {
      process.browser && dispatch('close');
    }, 3000);
    activationStatus$.next(0);
  });

  function handleClickOk() {
    dispatch('close');
  }
</script>

<Modal visible style="max-width: 400px;">
  <div class="f16 fw3 tc">{LG(lang.WelcomeBack)}</div>
  <div class="mt12 tc">{LG(lang.YourAccountHas)}</div>
  <div class="mt20 tc">
    <Button type="primary" size="small" on:click={handleClickOk}>{LG(lang.OK)}</Button>
  </div>
</Modal>
